export default "__VITE_ASSET__U4J1Mbj7__"